export default __webpack_public_path__ + "static/media/exterior-3.421fb36b.webp";